import gql from 'graphql-tag';

export const suggestedCredentialFragment = gql`
  fragment suggestedCredentialFragment on SuggestedCredential {
    dokkioClass
    credentialOAuthType
    otherUsersCount
  }
`;
export default suggestedCredentialFragment;
